export const hasMultilineAddress = (form) => {
    return Boolean([...(form?.fields || []), ...(form?.deletedFields || [])].some((field) => field.view?.fieldType === 'MULTILINE_ADDRESS'));
};
//# sourceMappingURL=has-multiline-address.js.map